// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"cde266b2","522":"927596d1","787":"f10595a5"}[chunkId] + ".chunk.js";
};